module.exports = __webpack_public_path__ + "img/cend1_en.5a5a161.png";